import React, { Component } from 'react';
import { Appointments, AppointmentTooltip } from '@devexpress/dx-react-scheduler-material-ui';
import { Box, Typography } from '@mui/material';

export class Appointment extends Component{ 
    render(){
        const { children, style, ...restProps } = this.props;
        return (
            <Appointments.Appointment
                {...restProps}
                style={{
                    ...style,
                    backgroundColor: restProps.data.color
                }}
            >
                {children}
                <Box p={1} style={{ color: 'white'}}>{restProps.data.timesheet_desc}</Box>
            </Appointments.Appointment>
        )
    }
}


class AppointmentContent extends Component{

    render(){
        const {children, appointmentData, ...restProps} = this.props;
        return(  
            <AppointmentTooltip.Content 
                {...restProps} 
                appointmentData={appointmentData}
            >
                <Box p={2}>
                    <Typography variant="subtitle1">{appointmentData.timesheet_desc}</Typography>
                </Box>
            </AppointmentTooltip.Content>
        )
    }
}
export default AppointmentContent;